package com.example.mystybag.sharedmodels.project.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetCitiesResponseModel(
    @SerialName("cities_list")
    val citiesList: List<CityResponseModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class CityResponseModel(
    val id: Long = 0L,
    @SerialName("city_name")
    val cityName: String = "",
    val longitude: Double = 0.0,
    val latitude: Double = 0.0,
    @SerialName("country_id")
    val countryId: Int = 0
)

